<template>

  <b-modal
    id="share-document-modal"
    :ok-title="$t(okTitle)"
    :title="$t('operationDocument.Share.Title')"
    ok-variant="primary"
    :cancel-title="$t('Cancel')"
    cancel-variant="outline-primary"
    :ok-only="this.okOnly"
    @ok="handleGenerate">

    <div class="row">
      <div class="col-md-6">
        <b-form-group
          :label="$t('OperationDocument.name')"
          class="medium-label mb-4"
          label-for="name-input">
          <b-form-input
            id="name-input"
            v-model="name"
            required
            type="text">
          </b-form-input>
        </b-form-group>
      </div>

      <div class="col-md-6">
        <b-form-group
          :label="$t('OperationDocument.Expiration')"
          class="medium-label mb-4"
          label-for="expiration-input">
          <b-form-select
            id="expiration-input"
            v-model="expiration"
            required>
            <option v-for="option in expirationList" :value="option">
              {{ $t(option) }}
            </option>
          </b-form-select>
        </b-form-group>
      </div>

      <div v-if="link === ''" class="col-md-12 mb-4">
        <p class="medium-label mb-1" style='font-family: "Montserrat-Bold", "Arial", sans-serif;'><b>{{ $t('operationDocument.Share.Documents') }}</b></p>
        <div v-for="document in documents">{{ document.tostring }}</div>
      </div>
      <div v-else class="col-md-12 mb-4">
        <b-form-group
          :label="$t('operationDocument.linkGenerated')"
          class="medium-label mb-4"
          label-for="name-input">
          <div class="row ml-1 mr-1">
            <b-form-input
              id="name-input"
              class="col-md-11"
              v-model="this.link"
              disabled
              type="text">
            </b-form-input>
            <button class="show-action-btn text-center col-md-1" @click=copyLink()>
              <copy-icon size="18"/>
            </button>
          </div>
        </b-form-group>

      </div>
    </div>

  </b-modal>

</template>

<script>

import AutocompleteField from "../../../components/b122/editFields/AutocompleteField.vue";
import MultiFileField from "../../../components/b122/editFields/MultiFileField.vue";
import AutoCompleteObjectField from "../../../components/b122/editFields/AutoCompleteObjectField.vue";
import api from "../../../services/api";

export default {

  name: "ShareDocumentsModal",

  components: {
    AutoCompleteObjectField,
    MultiFileField,
    AutocompleteField
  },

  props: {
    operationId: {
      default: null
    },
    documents: {
      type: Array,
      default: null
    },
  },

  data() {
    let okTitle = 'operationDocument.generateLink'
    return {
      okOnly: false,
      link: '',
      expirationList: ['24h', '48h', '7 jours'],
      okTitle: okTitle,
      name: null,
      expiration: '24h'
    }
  },

  methods: {

    handleGenerate(bvModalEvent) {
      if (this.link === '') {
        bvModalEvent.preventDefault()
        if (this.name) {
          let data = new FormData()
          data.append('name', this.name)
          data.append('expiration', this.expiration)
          data.append('documents', JSON.stringify(this.documents))
          data.append('operationId', this.operationId)

          api({
            method: 'POST',
            url: `partage/shareDocuments`,
            data: data
          })
            .then(response => {
              this.link = response.data.link
              this.okTitle = 'operationDocument.terminer'
              this.okOnly = true
            })
            .catch((error) => {

            })
        } else {
          this.errorToast()
        }
      } else {
        this.hideModal()
      }
    }
    ,

    resetModal() {
      this.name = null
      this.expiration = '24h'
      this.link = ''
      this.okTitle = 'operationDocument.generateLink'
      this.okOnly = false
    }
    ,

    hideModal() {
      this.resetModal()
      this.$bvModal.hide('share-document-modal')
    }
    ,

    copyLink() {
      navigator.clipboard.writeText(this.link);
      this.$bvToast.toast(this.$i18n.t('operationDocument.copied'), {
        autoHideDelay: 3000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: "success",
        solid: true,
      })
    }
    ,

    errorToast() {
      this.$bvToast.toast(this.$i18n.t('MandatoryFields'), {
        autoHideDelay: 3000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: "danger",
        solid: true,
      })
    }

  }

}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/operationBilan/components/ShareDocumentsModal.vue